import { tryParseDockerfile } from "../../shared/dockerfile";
import { volumeIsReadOnly } from "../../shared/volumes/types";

export function stepStorageVolumeName(dockerfileContent: string | undefined) {
  const volumes = tryParseDockerfile(dockerfileContent ?? "")
    .filter((instruction) => instruction.kind === "volume")
    .map((instruction) => instruction.volume);
  return (
    (volumes.find((v) => !volumeIsReadOnly(v)) ?? volumes[0])?.name ?? null
  );
}
